var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-content-count"},[_vm._v(" "+_vm._s(_vm.$t("{0} available", [_vm.$tc(_vm.countName, _vm.contentCount)]))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }